<script setup lang="ts">
import { mdiYoutube } from '@mdi/js'

const props = defineProps<{ videoId: string }>()
const isPlaying = ref(false)
</script>

<template>
  <div class="yt-player">
    <div
      v-if="!isPlaying"
      class="yt-thumb"
      @click="isPlaying = true"
    >
      <v-img
        :src="`https://img.youtube.com/vi/${props.videoId}/sddefault.jpg`"
        :alt="`YouTube thumbnail ${props.videoId}`"
        class="yt-thumb__img"
        loading="lazy"
        cover
      />
      <v-btn
        class="yt-thumb__button"
        icon
        variant="text"
        size="x-large"
        elevation="0"
        aria-label="再生"
      >
        <v-icon
          color="red"
          size="48"
          :icon="mdiYoutube"
        />
      </v-btn>
    </div>
    <div
      v-else
      class="yt-iframe-wrap"
    >
      <iframe
        :src="`https://www.youtube.com/embed/${props.videoId}?autoplay=1&rel=0&playsinline=1`"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="yt-iframe"
      />
    </div>
  </div>
</template>

<style>
.yt-player {
  height: 100%;
  max-width: 1280px;
  aspect-ratio: 16 / 9;
  position: relative;
  display: flex;
  justify-self: center;
  align-items: center;
  box-shadow: 0 0 6px rgba(0,0,0,0.5);
  overflow: hidden;
}
/* #734: モバイルの浮遊ダイアログ（LargeDialog の .fantasy-dialog--mobile）では
   本文 .fantasy-dialog-text が height:auto になる。デスクトップのように親の確定
   高さを前提に height:100% で高さを取ると、確定高さが無いため .yt-player が 0 に
   潰れ（aspect-ratio がその 0 から幅も導出して 0×0 になる）、サムネイル/動画が
   出ずタップもできない。モバイルでは幅基準（width:100% + aspect-ratio）に切り替え、
   高さは aspect-ratio から導出する。 */
.fantasy-dialog--mobile .yt-player {
  width: 100%;
  height: auto;
}
.yt-thumb {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.yt-thumb__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.yt-thumb__button {
  position: absolute !important; /* Vuetifyのposition上書きのため!important */
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  /* background: rgba(255,255,255,0.88); */
}
.yt-iframe-wrap, .yt-iframe {
  width: 100%;
  height: 100%;
}
</style>
